export const InsuranceSection = () => {
  const insurances = [
    {
      name: 'Bradesco Saúde',
      logo: 'https://public.readdy.ai/ai/img_res/c491b368-1030-40b5-9a3b-9f9bcba5cab6.png'
    },
    {
      name: 'Hapvida',
      logo: 'https://public.readdy.ai/ai/img_res/56f0f2f0-3e5c-46c1-8d74-88521767fe64.png'
    },
    {
      name: 'Postal Saúde',
      logo: 'https://public.readdy.ai/ai/img_res/cd9e5db8-0404-4307-a02e-45a3cc8516d5.png'
    },
    {
      name: 'Extremamedic',
      logo: 'https://public.readdy.ai/ai/img_res/5e6ec0f1-1a11-4f6e-9b7b-4a1ee11c75f9.png'
    },
    {
      name: 'CASSI',
      logo: 'https://static.readdy.ai/image/060e1c25caffef29cb7917b5a22faf7c/0fb72f73c33a1db56a898335af6866de.jpeg'
    }
  ];

  return (
    <section id="convenios" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-hospital-line"></i>
            <span>Convênios Aceitos</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Trabalhamos com os Principais Planos de Saúde
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Aceitamos diversos convênios para facilitar seu acesso aos nossos serviços de diagnóstico por imagem.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 max-w-5xl mx-auto mb-12">
          {insurances.map((insurance, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 flex items-center justify-center border border-gray-100 group h-32"
            >
              <img
                src={insurance.logo}
                alt={insurance.name}
                className="max-w-full max-h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 text-center">
          <div className="flex items-center justify-center mb-4">
            <i className="ri-question-line text-4xl text-teal-600"></i>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Não encontrou seu convênio?
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Entre em contato conosco para verificar se atendemos seu plano de saúde. Também realizamos atendimentos particulares com valores acessíveis.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+553534311899"
              className="inline-flex items-center justify-center space-x-2 bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 transition-all font-medium cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              <span>Ligar Agora</span>
            </a>
            <a
              href="https://wa.me/5535988228452"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center space-x-2 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-all font-medium cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}